import constants from "../constants";

export default function ajaxError(url, status) {
  return {
    type: constants.AJAX_ERROR,
    data: {
      url,
      status,
    },
  };
}


// WEBPACK FOOTER //
// ./assets/shared/actions/ajaxError.js